import React, { useContext } from 'react';
import { CitaContext } from '../../context/CitaContext';

const CAMPOS_CLIENTE = [
  { name: 'nombre', label: 'Nombre', icon: 'fas fa-user', type: 'text', placeholder: 'Ingrese su nombre' },
  { name: 'apellido', label: 'Apellido', icon: 'fas fa-user', type: 'text', placeholder: 'Ingrese su apellido' },
  { name: 'cedula', label: 'Cedula/ID', icon: 'fas fa-id-card', type: 'text', placeholder: 'Ingrese su numero de cedula' },
  { name: 'email', label: 'Email', icon: 'fas fa-envelope', type: 'email', placeholder: 'ejemplo@correo.com' },
  { name: 'telefono', label: 'Telefono', icon: 'fas fa-phone', type: 'tel', placeholder: 'Ejemplo: 098-555-1234' }
];

const CampoInput = ({ campo, value, onChange }) => (
  <div className="booking-field">
    <label className="booking-label">
      {campo.label} <span className="required">*</span>
    </label>
    <div className="booking-input-wrap">
      <i className={`${campo.icon} booking-input-icon`}></i>
      <input
        type={campo.type}
        name={campo.name}
        value={value}
        onChange={onChange}
        className={`booking-input ${value ? '' : 'input-error'}`.trim()}
        placeholder={campo.placeholder}
        aria-invalid={!value}
        required
      />
    </div>
  </div>
);

const FormularioDatos = () => {
  const { datosCliente, setDatosCliente } = useContext(CitaContext);
  
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setDatosCliente({
      ...datosCliente,
      [name]: value
    });
  };

  return (
    <div style={{ width: '100%' }}>
      <p className="booking-info">
        <i className="fas fa-user-check"></i>
        Ingrese sus datos personales para agendar la cita. Todos los campos son obligatorios.
      </p>

      <div className="booking-grid-two">
        {CAMPOS_CLIENTE.slice(0, 2).map((campo) => (
          <CampoInput
            key={campo.name}
            campo={campo}
            value={datosCliente[campo.name]}
            onChange={handleInputChange}
          />
        ))}
      </div>

      {CAMPOS_CLIENTE.slice(2).map((campo) => (
        <CampoInput
          key={campo.name}
          campo={campo}
          value={datosCliente[campo.name]}
          onChange={handleInputChange}
        />
      ))}
    </div>
  );
};

export default FormularioDatos;